function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../lib/saito/ui/saito-overlay/saito-overlay.js');
var DialerTemplate = require('./dialer.template.js');
var SaitoUser = require('../../../../lib/saito/ui/saito-user/saito-user');

/**
 *
 * This is a splash screen for calling/answering a P2P Stun call
 *
 **/
var Dialer = /*#__PURE__*/function () {
  function Dialer(app, mod) {
    _classCallCheck(this, Dialer);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.receiver = {};
    this.call_log = [];
  }
  return _createClass(Dialer, [{
    key: "render",
    value: function render(call_receiver) {
      var _this = this;
      var making_call = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (Array.isArray(call_receiver)) {
        var _iterator = _createForOfIteratorHelper(call_receiver),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var cr = _step.value;
            if (!this.receiver[cr]) {
              this.receiver[cr] = new SaitoUser(this.app, this.mod, '.stun-minimal-appspace .contact', cr);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else if (call_receiver) {
        if (!this.receiver[call_receiver]) {
          this.receiver[call_receiver] = new SaitoUser(this.app, this.mod, '.stun-minimal-appspace .contact', call_receiver);
        }
      }
      this.overlay.show(DialerTemplate(this.app, this.mod, making_call), function () {
        if (making_call) {
          _this.app.connection.emit('relay-send-message', {
            recipient: Object.keys(_this.receiver),
            request: 'stun-connection-request-cancel',
            data: _this.mod.room_obj
          });
        } else {
          _this.app.connection.emit('relay-send-message', {
            recipient: Object.keys(_this.receiver),
            request: 'stun-connection-rejected',
            data: _this.mod.room_obj
          });
        }
        _this.remove();
      });
      this.overlay.blockClose();
      for (var _i = 0, _Object$values = Object.values(this.receiver); _i < _Object$values.length; _i++) {
        var r = _Object$values[_i];
        r.render();
      }
      this.attachEvents();
      if (!making_call) {
        this.ring_sound = new Audio('/saito/sound/Reverie_edit.mp3');
        this.startRing(6000);
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var video_switch = document.getElementById('video_call_switch');
      var call_button = document.getElementById('startcall');
      var recipient = Object.keys(this.receiver);
      if (video_switch && call_button) {
        this.activateOptions();
        call_button.onclick = function (e) {
          if (_this2.call_log.length > 3) {
            salert('You are making too many calls... please try again later');
            return;
          }
          _this2.mod.room_obj.ui = video_switch.checked ? 'video' : 'voice';
          var data = Object.assign({}, _this2.mod.room_obj);

          //
          // We will block you from trying to make more than 3 phone calls in a 60 second span
          // to prevent spamming
          //
          _this2.call_log.push(recipient);
          setTimeout(function () {
            if (_this2.call_log.length > 0) {
              _this2.call_log.shift();
            }
          }, 60000);
          _this2.ring_sound = new Audio('/saito/sound/Cloud_edit.mp3');
          _this2.startRing(4500);
          _this2.updateMessage('Dialing...');
          _this2.deactivateOptions();
          if (!recipient || recipient.length == 0) {
            call_button.innerHTML = 'starting call...';
            setTimeout(function () {
              _this2.stopRing();
              _this2.overlay.remove();
              _this2.app.connection.emit('start-game-call');
            }, 2000);
            return;
          }
          _this2.app.connection.emit('relay-send-message', {
            recipient: recipient,
            request: 'stun-connection-request',
            data: data
          });
          _this2.dialing = setTimeout(function () {
            _this2.app.connection.emit('relay-send-message', {
              recipient: recipient,
              request: 'stun-connection-request-cancel',
              data: data
            });
            _this2.stopRing();
            call_button.innerHTML = 'Call';
            _this2.updateMessage('No answer');
            _this2.attachEvents();
          }, 3000);
          call_button.innerHTML = 'Cancel';
          call_button.onclick = function (e) {
            clearTimeout(_this2.dialing);
            _this2.app.connection.emit('relay-send-message', {
              recipient: recipient,
              request: 'stun-connection-request-cancel',
              data: data
            });
            _this2.remove();
          };
        };
      }

      /////////////////////////////
      // For answering phone calls
      /////////////////////////////
      var answer_button = document.getElementById('answercall');
      var reject_button = document.getElementById('rejectcall');
      if (answer_button) {
        answer_button.onclick = function (e) {
          _this2.app.connection.emit('relay-send-message', {
            recipient: recipient,
            request: 'stun-connection-accepted',
            data: _this2.mod.room_obj
          });
          _this2.remove(false);
          _this2.updateMessage('connecting...');
          setTimeout(function () {
            _this2.overlay.remove();
            _this2.app.connection.emit('stun-init-call-interface', {
              ui: _this2.mod.room_obj.ui,
              audio: true,
              video: _this2.mod.room_obj.ui == 'video',
              auto_disconnect: recipient.length > 0
            });
            _this2.app.connection.emit('start-stun-call');
          }, 1000);
        };
      }
      if (reject_button) {
        reject_button.onclick = function (e) {
          _this2.app.connection.emit('relay-send-message', {
            recipient: recipient,
            request: 'stun-connection-rejected',
            data: _this2.mod.room_obj
          });
          _this2.remove();
        };
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      var closeOverlay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.stopRing();
      this.app.connection.emit('close-preview-window');
      this.receiver = {};
      if (this.dialing) {
        clearTimeout(this.dialing);
        this.dialing = null;
      }
      if (closeOverlay) {
        this.app.connection.emit('reset-stun');
        this.overlay.remove();
      }
    }
  }, {
    key: "startRing",
    value: function startRing(interval) {
      var _this3 = this;
      if (this.ringer) {
        clearInterval(this.ringer);
      }
      this.ring_sound.play();
      this.ringer = setInterval(function () {
        try {
          _this3.ring_sound.play();
        } catch (err) {
          console.error(err);
        }
      }, interval);
    }
  }, {
    key: "stopRing",
    value: function stopRing() {
      try {
        if (this.ring_sound) {
          this.ring_sound.pause();
        }
        if (this.ringer) {
          clearInterval(this.ringer);
          this.ringer = null;
        }
      } catch (err) {
        console.error(err);
      }
    }
  }, {
    key: "updateMessage",
    value: function updateMessage(message) {
      var div = document.getElementById('stun-phone-notice');
      if (div) {
        div.innerHTML = message;
      }
    }
  }, {
    key: "activateOptions",
    value: function activateOptions() {
      var div = document.querySelector('.video_switch');
      if (div) {
        div.classList.remove('deactivated');
      }
      var video_switch = document.getElementById('video_call_switch');
    }
  }, {
    key: "deactivateOptions",
    value: function deactivateOptions() {
      var div = document.querySelector('.video_switch');
      div.classList.add('deactivated');
      var video_switch = document.getElementById('video_call_switch');
      video_switch.onchange = null;
    }
  }, {
    key: "establishStunCallWithPeers",
    value: function () {
      var _establishStunCallWithPeers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this4 = this;
        var recipients,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              recipients = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
              if (this.mod.room_obj) {
                _context.n = 1;
                break;
              }
              _context.n = 1;
              return this.mod.createRoom();
            case 1:
              // send the information to the other peers and ask them to join the call

              recipients = recipients.filter(function (player) {
                return player !== _this4.mod.publicKey;
              });
              this.render(recipients, true);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function establishStunCallWithPeers() {
        return _establishStunCallWithPeers.apply(this, arguments);
      }
      return establishStunCallWithPeers;
    }()
  }, {
    key: "receiveStunCallMessageFromPeers",
    value: function receiveStunCallMessageFromPeers(tx) {
      var _this$app$options$stu,
        _this$mod,
        _this5 = this;
      var txmsg = tx.returnMessage();
      var sender = tx.from[0].publicKey;
      var data = txmsg.data;
      switch (txmsg.request) {
        case 'stun-connection-request':
          //
          // Screen the call
          //
          var privacy = ((_this$app$options$stu = this.app.options.stun) === null || _this$app$options$stu === void 0 || (_this$app$options$stu = _this$app$options$stu.settings) === null || _this$app$options$stu === void 0 ? void 0 : _this$app$options$stu.privacy) || 'all';
          if (privacy == 'none') {
            return;
          }
          if (privacy == 'dh' && !this.app.keychain.hasSharedSecret(sender)) {
            return;
          }
          if (privacy == 'key' && !this.app.keychain.hasPublicKey(sender)) {
            return;
          }
          if (!this.mod.room_obj) {
            this.mod.room_obj = txmsg.data;
            this.render(sender, false);

            //
            // Ping back to let caller know I am online
            //
            this.app.connection.emit('relay-send-message', {
              recipient: sender,
              request: 'stun-connection-ping',
              data: data
            });
          }
          console.debug('Talk.dialer [stun-connection-request]:', this.mod.room_obj);
          break;
        case 'stun-connection-request-cancel':
          if (((_this$mod = this.mod) === null || _this$mod === void 0 || (_this$mod = _this$mod.room_obj) === null || _this$mod === void 0 ? void 0 : _this$mod.call_id) == data.call_id) {
            this.remove();
            siteMessage("".concat(this.app.keychain.returnUsername(sender), " hung up"), 2000);
          }
          break;
        case 'stun-connection-rejected':
          this.stopRing();
          clearTimeout(this.dialing);
          this.updateMessage('did not answer');
          if (document.getElementById('startcall')) {
            document.getElementById('startcall').innerHTML = 'Call';
          }
          this.attachEvents();
          break;
        case 'stun-connection-accepted':
          this.remove(false);
          this.updateMessage('connecting...');
          setTimeout(function () {
            _this5.overlay.remove();
            _this5.app.connection.emit('stun-init-call-interface', {
              ui: _this5.mod.room_obj.ui,
              audio: true,
              video: _this5.mod.room_obj.ui == 'video',
              auto_disconnect: true
            });
            _this5.app.connection.emit('start-stun-call');
          }, 1000);
          break;
        case 'stun-connection-ping':
          if (this.dialing) {
            clearTimeout(this.dialing);
            this.dialing = setTimeout(function () {
              _this5.app.connection.emit('relay-send-message', {
                recipient: sender,
                request: 'stun-connection-request-cancel',
                data: data
              });
              _this5.stopRing();
              if (document.getElementById('startcall')) {
                document.getElementById('startcall').innerHTML = 'Call';
              }
              _this5.updateMessage('No answer');
              _this5.attachEvents();
            }, 29000);
          }
        default:
      }
    }
  }]);
}();
module.exports = Dialer;